// frontend/src/modules/folha/components/HoleriteHeader.js
import React from 'react';
import Logo from '../../../components/Logo';

function HoleriteHeader({ empresa, funcionario, mesReferencia, anoReferencia, tipo = 'holerite' }) {
  return (
    <div style={{
      textAlign: 'center',
      padding: '20px',
      borderBottom: '2px solid #333',
      marginBottom: '20px'
    }}>
      {/* Logo da Empresa */}
      {empresa?.id && (
        <div style={{ marginBottom: '10px' }}>
          <Logo 
            empresaId={empresa.id} 
            size="large"
            showName={false}
          />
        </div>
      )}
      
      {/* Nome da Empresa */}
      <h2 style={{ margin: '5px 0', fontSize: '22px', color: '#1a237e' }}>
        {empresa?.nome_fantasia || empresa?.nome_empresa || 'Empresa'}
      </h2>
      
      {/* Dados da Empresa */}
      <div style={{ fontSize: '12px', color: '#6c757d' }}>
        <p style={{ margin: '2px 0' }}>
          {empresa?.cnpj && `CNPJ: ${empresa.cnpj}`}
          {empresa?.inscricao_estadual && ` | IE: ${empresa.inscricao_estadual}`}
        </p>
        <p style={{ margin: '2px 0' }}>
          {empresa?.logradouro && `${empresa.logradouro}, ${empresa.numero || ''}`}
          {empresa?.bairro && ` - ${empresa.bairro}`}
          {empresa?.cidade && ` - ${empresa.cidade}`}
          {empresa?.estado && `/${empresa.estado}`}
        </p>
        <p style={{ margin: '2px 0' }}>
          {empresa?.telefone && `📞 ${empresa.telefone}`}
          {empresa?.email && ` | ✉️ ${empresa.email}`}
        </p>
      </div>

      {/* Título do Documento */}
      <div style={{
        marginTop: '15px',
        padding: '10px',
        backgroundColor: '#f8f9fa',
        borderRadius: '4px'
      }}>
        <h3 style={{ margin: 0, fontSize: '18px', color: '#1a237e' }}>
          {tipo === 'holerite' ? '📄 HOLERITE' : '💰 ADIANTAMENTO SALARIAL'}
        </h3>
        <p style={{ margin: '5px 0 0 0', fontSize: '14px', color: '#495057' }}>
          <strong>Funcionário:</strong> {funcionario?.nome_completo || funcionario?.nome || '---'}
        </p>
        <p style={{ margin: '2px 0', fontSize: '13px', color: '#6c757d' }}>
          <strong>Referência:</strong> {mesReferencia}/{anoReferencia}
        </p>
        {funcionario?.cargo && (
          <p style={{ margin: '2px 0', fontSize: '13px', color: '#6c757d' }}>
            <strong>Cargo:</strong> {funcionario.cargo}
          </p>
        )}
        {funcionario?.departamento && (
          <p style={{ margin: '2px 0', fontSize: '13px', color: '#6c757d' }}>
            <strong>Departamento:</strong> {funcionario.departamento}
          </p>
        )}
      </div>
    </div>
  );
}

export default HoleriteHeader;